<div class="d-flex align-items-center justify-content-between">
  <div class="branding">
    <h5 class="f-s-16">Sociedad Mutualista "El Seguro del Maestro"</h5>
      <a href="/">
        <!-- <img  src="./assets/images/logos/logo-sdm-hrz.png" class="align-middle m-2" alt="logo" />  -->
      </a>
  </div>
  <!-- <app-branding></app-branding> -->

  <ng-container *ngIf="showToggle">
    <a href="javascript:void(0)"
      (click)="toggleMobileNav.emit()"
      class="d-flex justify-content-center ng-star-inserted icon-40 align-items-center mat-body-1">
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </a>
  </ng-container>
  
</div>
